'use strict';

import * as moment from 'moment';

(function () {
  angular
    .module('specsguardApp')
    .filter('sgDateAgo', sgDateAgo);

  sgDateAgo.$inject = ['$log', 'Labels', 'sg2UserService'];

  /**
   * sgDateAgo is a filter to display the date in a more readable annotation
   * Instead of showing the timestamp like: vrijdag 16 november 2018 13:32:50
   * we can display it as following: 2 dagen geleden, 1 jaar geleden, 1 uur geleden.
   * */
  function sgDateAgo($log, Labels, sg2UserService) {

    return function (value) {
      // Return a placeholder + error when date isn't set
      if (angular.isUndefined(value) || value === null) {
        $log.error('date not set!');
        return '-';
      }

      moment.locale(sg2UserService.getLanguage());
      return moment(new Date(value)).fromNow();
    };
  }
})();
